import { render, staticRenderFns } from "./Draft.vue?vue&type=template&id=171c8642&scoped=true&"
import script from "./Draft.vue?vue&type=script&lang=ts&"
export * from "./Draft.vue?vue&type=script&lang=ts&"
import style0 from "./Draft.vue?vue&type=style&index=0&id=171c8642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171c8642",
  null
  
)

export default component.exports